/**
 * แปลง merchants ให้เป็น string[] (array ของ merchant_id) เท่านั้น
 * รองรับทั้งกรณีที่รับมาเป็น string[] หรือ array of objects ที่มี merchant_id
 */
export const toMerchantIdArray = (merchants: unknown): string[] => {
  if (!merchants || !Array.isArray(merchants) || merchants.length === 0) return [];
  return merchants
    .map((m: any) => (typeof m === "string" ? m : m?.merchant_id))
    .filter((id): id is string => !!id);
};
